import React, { useRef } from 'react';
import CodeHighlight from './../../components/code-highlight/code-highlight.jsx';
import useTemplateInteractions from './../../composables/templateInteractions.js';

function UISocialButtons() {
	const rootRef = useRef(null);
	useTemplateInteractions(rootRef);

	return (
		<div ref={rootRef}>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<ul className="breadcrumb">
									<li className="breadcrumb-item">
										<a href="#/">{'UI Elements'}</a>
									</li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header">
									{' Social Buttons '}
									<small>{'page header description goes here...'}</small>
								</h1>
								<hr className="mb-4" />
								<div id="usage" className="mb-5">
									<h4>{'Usage'}</h4>
									<p>
										{
											' Use the Bootstrap Social library to create branded social media buttons. Combine '
										}
										<code>{'btn'}</code>
										{' classes with network-specific styles (e.g., '}
										<code>{'btn-facebook'}</code>
										{', '}
										<code>{'btn-twitter'}</code>
										{
											') to add ready-made icons and colors for quick social sign-in or sharing links. Please read the '
										}
										<a href="https://lipis.github.io/bootstrap-social/" target="_blank" rel="noreferrer">
											{'official bootstrap social documentation'}
										</a>
										{' for the full list of options. '}
									</p>
									<div className="card">
										<div className="card-body p-0">
											<div data-scrollbar="true" data-height="55vh" data-wheel-propagation="true">
												<div className="table-responsive">
													<table className="table table-striped table-condensed text-nowrap m-0 table-panel">
														<thead>
															<tr>
																<th>{'Buttons'}</th>
																<th>{'class=""'}</th>
																<th>{'Color Code'}</th>
															</tr>
														</thead>
														<tbody>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-adn"
																	>
																		<span className="fab fa-adn"></span>
																		{' Sign in with App.net '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-adn'}</code>
																</td>
																<td>{'#D87A68'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-bitbucket"
																	>
																		<span className="fab fa-bitbucket"></span>
																		{' Sign in with Bitbucket '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-bitbucket'}</code>
																</td>
																<td>{'#205081'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-dropbox"
																	>
																		<span className="fab fa-dropbox"></span>
																		{' Sign in with Dropbox '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-dropbox'}</code>
																</td>
																<td>{'#1087DD'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-facebook"
																	>
																		<span className="fab fa-facebook"></span>
																		{' Sign in with Facebook '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-facebook'}</code>
																</td>
																<td>{'#3B5998'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-flickr"
																	>
																		<span className="fab fa-flickr"></span>
																		{' Sign in with Flickr '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-flickr'}</code>
																</td>
																<td>{'#2BA9E1'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-foursquare"
																	>
																		<span className="fab fa-foursquare"></span>
																		{' Sign in with Foursquare '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-foursquare'}</code>
																</td>
																<td>{'#f94877'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-github"
																	>
																		<span className="fab fa-github"></span>
																		{' Sign in with GitHub '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-github'}</code>
																</td>
																<td>{'#444444'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-google"
																	>
																		<span className="fab fa-google"></span>
																		{' Sign in with Google '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-google'}</code>
																</td>
																<td>{'#DD4B39'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-instagram"
																	>
																		<span className="fab fa-instagram"></span>
																		{' Sign in with Instagram '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-instagram'}</code>
																</td>
																<td>{'#3F729B'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-linkedin"
																	>
																		<span className="fab fa-linkedin"></span>
																		{' Sign in with LinkedIn '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-linkedin'}</code>
																</td>
																<td>{'#007BB6'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-microsoft"
																	>
																		<span className="fab fa-windows"></span>
																		{' Sign in with Microsoft '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-microsoft'}</code>
																</td>
																<td>{'#2672EC'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-odnoklassniki"
																	>
																		<span className="fab fa-odnoklassniki"></span>
																		{' Sign in with Odnoklassniki '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-odnoklassniki'}</code>
																</td>
																<td>{'#F4731C'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-openid"
																	>
																		<span className="fab fa-openid"></span>
																		{' Sign in with OpenID '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-openid'}</code>
																</td>
																<td>{'#F7931E'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-pinterest"
																	>
																		<span className="fab fa-pinterest"></span>
																		{' Sign in with Pinterest '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-pinterest'}</code>
																</td>
																<td>{'#CB2027'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-reddit"
																	>
																		<span className="fab fa-reddit"></span>
																		{' Sign in with Reddit '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-reddit'}</code>
																</td>
																<td>{'#EFF7FF'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-soundcloud"
																	>
																		<span className="fab fa-soundcloud"></span>
																		{' Sign in with SoundCloud '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-soundcloud'}</code>
																</td>
																<td>{'#FF5500'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-tumblr"
																	>
																		<span className="fab fa-tumblr"></span>
																		{' Sign in with Tumblr '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-tumblr'}</code>
																</td>
																<td>{'#CB2027'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-twitter"
																	>
																		<span className="fab fa-twitter"></span>
																		{' Sign in with Twitter '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-twitter'}</code>
																</td>
																<td>{'#55ACEE'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-vimeo"
																	>
																		<span className="fab fa-vimeo-square"></span>
																		{' Sign in with Vimeo '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-vimeo'}</code>
																</td>
																<td>{'#1AB7EA'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-vk"
																	>
																		<span className="fab fa-vk"></span>
																		{' Sign in with VK '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-vk'}</code>
																</td>
																<td>{'#587EA3'}</td>
															</tr>
															<tr>
																<td className="with-btn">
																	<a
																		href="#/"
																		className="btn btn-sm w-250px btn-social btn-yahoo"
																	>
																		<span className="fab fa-yahoo"></span>
																		{' Sign in with Yahoo! '}
																	</a>
																</td>
																<td>
																	<code>{'btn btn-social btn-yahoo'}</code>
																</td>
																<td>{'#720E9E'}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-social-buttons/code-1.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="socialIcons" className="mb-5">
									<h4>{'Social Icons'}</h4>
									<p>
										{
											' Add social media icons to your interface by combining your preferred icon library (such as Font Awesome or Bootstrap Icons) with the '
										}
										<code>{'.btn-social-icon'}</code>
										{
											' class. This creates clean, clickable buttons that link to profiles, sharing tools, or login options. '
										}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="d-flex flex-wrap gap-2 w-50">
												<div>
													<a href="#/" className="btn btn-social-icon btn-adn">
														<span className="fab fa-adn"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-bitbucket">
														<span className="fab fa-bitbucket"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-dropbox">
														<span className="fab fa-dropbox"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-facebook">
														<span className="fab fa-facebook"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-flickr">
														<span className="fab fa-flickr"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-foursquare">
														<span className="fab fa-foursquare"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-github">
														<span className="fab fa-github"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-google">
														<span className="fab fa-google"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-instagram">
														<span className="fab fa-instagram"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-linkedin">
														<span className="fab fa-linkedin"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-microsoft">
														<span className="fab fa-windows"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-odnoklassniki">
														<span className="fab fa-odnoklassniki"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-openid">
														<span className="fab fa-openid"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-pinterest">
														<span className="fab fa-pinterest"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-reddit">
														<span className="fab fa-reddit"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-soundcloud">
														<span className="fab fa-soundcloud"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-tumblr">
														<span className="fab fa-tumblr"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-twitter">
														<span className="fab fa-twitter"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-vimeo">
														<span className="fab fa-vimeo-square"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-vk">
														<span className="fab fa-vk"></span>
													</a>
												</div>
												<div>
													<a href="#/" className="btn btn-social-icon btn-yahoo">
														<span className="fab fa-yahoo"></span>
													</a>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-social-buttons/code-2.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="sizes" className="mb-5">
									<h4>{'Sizes'}</h4>
									<p>
										{' Adjust icon dimensions with predefined size classes such as '}
										<code>{'fa-sm'}</code>
										{', '}
										<code>{'fa-lg'}</code>
										{', or '}
										<code>{'fa-2x'}</code>
										{' through '}
										<code>{'fa-10x'}</code>
										{
											'. These utilities make it easy to scale icons for buttons, headings, or any element that needs visual balance. '
										}
									</p>
									<div className="card">
										<div className="card-body d-flex flex-column gap-3">
											<div className="d-flex gap-1">
												<a href="#/" className="btn btn-social btn-lg btn-facebook">
													<i className="fab fa-facebook-f"></i>
													{'Sign in with Facebook'}
												</a>
												<a href="#/" className="btn btn-social-icon btn-lg btn-facebook">
													<i className="fab fa-facebook-f"></i>
												</a>
											</div>
											<div className="d-flex gap-1">
												<a href="#/" className="btn btn-social btn-facebook">
													<i className="fab fa-facebook-f"></i>
													{'Sign in with Facebook'}
												</a>
												<a href="#/" className="btn btn-social-icon btn-facebook">
													<i className="fab fa-facebook-f"></i>
												</a>
											</div>
											<div className="d-flex gap-1">
												<a href="#/" className="btn btn-social btn-sm btn-facebook">
													<i className="fab fa-facebook-f"></i>
													{'Sign in with Facebook'}
												</a>
												<a href="#/" className="btn btn-social-icon btn-sm btn-facebook">
													<i className="fab fa-facebook-f"></i>
												</a>
											</div>
											<div className="d-flex gap-1">
												<a href="#/" className="btn btn-social btn-xs btn-facebook">
													<i className="fab fa-facebook-f"></i>
													{'Sign in with Facebook'}
												</a>
												<a href="#/" className="btn btn-social-icon btn-xs btn-facebook">
													<i className="fab fa-facebook-f"></i>
												</a>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-social-buttons/code-3.json"
												/>
											</pre>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3">
								<nav
									data-init="scrollspy"
									className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100"
								>
									<nav className="nav">
										<a className="nav-link active" href="#usage" data-toggle="scroll-to">
											{'Usage'}
										</a>
										<a className="nav-link" href="#socialIcons" data-toggle="scroll-to">
											{'Social Icons'}
										</a>
										<a className="nav-link" href="#sizes" data-toggle="scroll-to">
											{'Sizes'}
										</a>
									</nav>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default UISocialButtons;
